import React from "react";
import { IoAdd, IoAlertCircle, IoArrowForward, IoCall, IoHelpCircle, IoInformationCircle } from "react-icons/io5";
import Main from "../../components/layout/Main";
import { useToggleTop } from "../../components/common/ToggleTop";

// The app's Extras page (app/screens/HomeExtrasScreen.js). The web opens the
// same pages in a new tab.
const LINKS = [
  { name: "What's new", icon: IoAlertCircle, url: "https://docs.hashh.io/books/hashh-connect-release-notes/" },
  { name: "FAQ", icon: IoHelpCircle, url: "https://www.hashh.io/faq/" },
  { name: "Privacy Policy", icon: IoInformationCircle, url: "https://www.hashh.io/privacy-policy/" },
  { name: "Contact Us", icon: IoCall, url: "https://www.hashh.io/" },
];

function Extras() {
  const toast = useToggleTop();

  return (
    <Main header="stack" title="Extras">
      <ul className="hx-list">
        <li>
          <button
            type="button"
            className="hx-list-item"
            onClick={() => toast("Set up new devices with the HASHh Connect app", "blue")}
          >
            <IoAdd aria-hidden="true" />
            <span className="hx-list-text">
              <span className="hx-list-title">Add device</span>
              <span className="hx-list-sub">Devices are set up from the mobile app</span>
            </span>
          </button>
        </li>
        {LINKS.map((link) => {
          const Icon = link.icon;
          return (
            <li key={link.name}>
              <a className="hx-list-item" href={link.url} target="_blank" rel="noopener noreferrer">
                <Icon aria-hidden="true" />
                <span className="hx-list-text">
                  <span className="hx-list-title">{link.name}</span>
                </span>
                <IoArrowForward className="hx-list-arrow" aria-hidden="true" />
              </a>
            </li>
          );
        })}
      </ul>
    </Main>
  );
}

export default Extras;
